module.exports = __webpack_public_path__ + "static/media/wheel-white.3a5f086f.svg";